<div class="toolbar" role="banner" id="toolbar">
  <button
  mat-button  
  
    (click)="OnMenu()"
    style=" outline: none; "
    matBadgeOverlap="false"
    id="meu"
  >
 
  <mat-icon  style="font-size: 40px;">subject</mat-icon>
    
  </button>
  <img
    
    alt="Angular Logo"
    src="../../../assets/logo-blanco-sin-fondo.png"
    style="width: 128px;
    height: 120px;
    opacity: 1;"
    routerLink="/home" routerLinkActive="active"
  />
  
  <div class="spacer"></div>
</div>
